import { render, staticRenderFns } from "./PositionOverlay.vue?vue&type=template&id=202fd1e8&scoped=true"
import script from "./PositionOverlay.vue?vue&type=script&lang=ts"
export * from "./PositionOverlay.vue?vue&type=script&lang=ts"
import style0 from "./PositionOverlay.vue?vue&type=style&index=0&id=202fd1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202fd1e8",
  null
  
)

export default component.exports